export const lang = {
    en: {
        required: 'This field is required',
        email: 'This field requires a valid e-mail address',
        number: 'This field requires a number',
        integer: 'This field requires an integer value',
        url: 'This field requires a valid website URL',
        tel: 'This field requires a valid telephone number',
        maxlength: 'This fields length must be < ${1}',
        minlength: 'This fields length must be > ${1}',
        min: 'Minimum value for this field is ${1}',
        max: 'Maximum value for this field is ${1}',
        pattern: 'Please match the requested format',
        equals: 'The two fields do not match',
        default: 'Please enter a correct value',
    },
    // pl: {
    //     email: 'To pole wymaga poprawnego adresu e-mail',
    //     number: 'To pole wymaga liczby',
    //     integer: 'To pole wymaga wartości całkowitej',
    //     url: 'To pole wymaga poprawnego adresu URL strony internetowej',
    //     tel: 'To pole wymaga poprawnego numeru telefonu',
    //     maxlength: 'Liczba znaków w tym polu musi wynosić mniej niż ${1}',
    //     minlength: 'Liczba znaków w tym polu musi wynosić przynajmniej ${1}',
    //     min: 'Minimalna wartość dla tego pola to ${1}',
    //     max: 'Maksymalna wartość dla tego pola to ${1}',
    //     pattern: 'Proszę dopasować się do żądanego formatu',
    //     equals: 'Dwa pola nie pasują do siebie',
    //     default: 'Proszę wprowadzić poprawną wartość',
    // },
}
